/**
 * Social Share Component
 * Share buttons for articles - Facebook, X (Twitter), LinkedIn, Email, Copy Link
 */

import { Facebook, Twitter, Linkedin, Link2, Mail } from "lucide-react"
import { toast } from "sonner"

export function SocialShare({ url, title, description }) {
  const encodedUrl = encodeURIComponent(url)
  const encodedTitle = encodeURIComponent(title)
  const encodedDesc = encodeURIComponent(description || "")

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    email: `mailto:?subject=${encodedTitle}&body=${encodedDesc}%0A%0ARead more: ${encodedUrl}`,
  }

  const openShareWindow = (url, name) => {
    window.open(url, name, "width=600,height=400,scrollbars=yes")
  }

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url)
      toast.success("Link copied to clipboard!")
    } catch (err) {
      toast.error("Failed to copy link")
    }
  }

  const buttonClass =
    "w-10 h-10 flex items-center justify-center rounded-full bg-zinc-100 text-zinc-600 hover:bg-kf-red hover:text-white transition-colors"

  return (
    <div className="flex items-center gap-4">
      <span className="text-sm text-zinc-500 uppercase tracking-wider font-semibold">
        Share
      </span>
      <div className="flex gap-2">
        <button
          onClick={() => openShareWindow(shareLinks.facebook, "facebook-share")}
          className={buttonClass}
          aria-label="Share on Facebook"
          title="Share on Facebook"
        >
          <Facebook className="w-5 h-5" />
        </button>

        <button
          onClick={() => openShareWindow(shareLinks.twitter, "twitter-share")}
          className={buttonClass}
          aria-label="Share on X (Twitter)"
          title="Share on X (Twitter)"
        >
          <Twitter className="w-5 h-5" />
        </button>

        <button
          onClick={() => openShareWindow(shareLinks.linkedin, "linkedin-share")}
          className={buttonClass}
          aria-label="Share on LinkedIn"
          title="Share on LinkedIn"
        >
          <Linkedin className="w-5 h-5" />
        </button>

        <a
          href={shareLinks.email}
          className={buttonClass}
          aria-label="Share via Email"
          title="Share via Email"
        >
          <Mail className="w-5 h-5" />
        </a>

        <button
          onClick={copyLink}
          className={buttonClass}
          aria-label="Copy link"
          title="Copy link"
        >
          <Link2 className="w-5 h-5" />
        </button>
      </div>
    </div>
  )
}
